import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=4ccbbee2&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=4ccbbee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbbee2",
  null
  
)

export default component.exports